import { action } from 'satcheljs';
export default action('toggleIgnoreConversations', function (rowKeysToIgnore, tableViewId, shouldIgnore, actionSource) { return ({
    rowKeysToIgnore: rowKeysToIgnore,
    tableViewId: tableViewId,
    shouldIgnore: shouldIgnore,
    actionSource: actionSource,
}); });
//# sourceMappingURL=toggleIgnoreConversations.js.map